﻿import { useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { hasPermission } from "@/services/Utils";
import { CHANGE_SELECT_INVENTORIES } from "@/redux/types/inventory.types";
import { useWindowSize } from "@/hooks/SizeHook";

import classes from "./inventory.module.scss";
import ButtonFilter from "@/components/Filter/ButtonFilter";
import { textConstants } from "@/languages/textConstants";

const InventoryFunctions = ({
	setTypePrint,
	handleShow,
	random,
	randomInventory,
	exportExcel,
	showFilter,
	setShowFilter,
	setShowDateExcel,
	locationFrom = null,
}) => {
	const size = useWindowSize();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [showLoad, setShowLoad] = useState(false);

	const { permissions, tags_available, lots_available } = useSelector((state) => state.inventory);
	const { user } = useSelector((state) => state.auth);
	const { tools } = user ? user : {};

	let countTags = 0;
	tags_available.forEach((tag) => {
		countTags += Number(tag.quantity_available);
	});

	return (
		<Row className={classes.header}>
			<ButtonFilter origin="actions" size_md={1} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Col md={11} sm={12} xs={12} className={classes.functionColBase}>
				<Row className={classes.rowOptionButton}>
					{hasPermission("create", permissions) && (
						<Col xs={6} className={classes.colOptionButton}>
							<div
								className={`${classes.optionButton} ${classes.newInventory}`}
								onClick={() => {
									dispatch({
										type: CHANGE_SELECT_INVENTORIES,
										payload: {
											selected: [],
										},
									});

									if (!tools.find((t) => t.id === 2)) {
										navigate("/ingresar_inventario");
									} else {
										setShowLoad(true);
									}
								}}
							>
								<span>Cargar</span>
							</div>
						</Col>
					)}

					{(countTags > 0 || locationFrom === "tour") && size.width > 750 && (
						<Col xs={6} className={classes.colOptionButton}>
							<div
								className={`${classes.optionButton} ${classes.printInventory}`}
								id="printerLableBtn"
								onClick={(_e) => {
									setTypePrint("new");
									handleShow();
								}}
							>
								<span>
									Etiqueta
									<span className={classes.floatNumber}>{countTags}</span>
								</span>
							</div>
						</Col>
					)}

					{lots_available.length > 0 && size.width > 750 && (
						<Col xs={6} className={classes.colOptionButton}>
							<div
								className={`${classes.optionButton} ${classes.printInventory}`}
								onClick={(_e) => {
									setTypePrint("lots");
									handleShow();
								}}
							>
								<span>
									Lote
									<span className={classes.floatNumber}>{lots_available.length}</span>
								</span>
							</div>
						</Col>
					)}

					<Col xs={6} className={classes.colOptionButton}>
						<div className={`${classes.optionButton} ${classes.randomInventory} ${random && classes.active}`} onClick={() => randomInventory()}>
							<span>Aleatorio</span>
						</div>
					</Col>

					<Col xs={6} className={classes.colOptionButton}>
						<div className={`${classes.optionButton} ${classes.exportInventory} `} onClick={() => setShowDateExcel(true)}>
							<span>Histórico</span>
						</div>
					</Col>

					<Col xs={6} className={classes.colOptionButton}>
						<div className={`${classes.optionButton} ${classes.exportInventory}`} onClick={() => exportExcel("new")}>
							<span>Excel</span>
						</div>
					</Col>
				</Row>
			</Col>

			{/* <hr className={classes.separator} /> */}

			<Modal show={showLoad} onHide={() => setShowLoad(false)} backdrop="static" keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: "1em" }}>¿Qué documento deseas cargar?</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ padding: "15px 11px" }}>
					<div className={classes.print_option}>
						<div
							className={`${classes.global_option} ${classes.sale}`}
							onClick={() => {
								setShowLoad(false);
								navigate("/facturas/crear");
							}}
						>
							<span>Factura</span>
						</div>
						<div
							className={`${classes.global_option} ${classes.delivery}`}
							onClick={() => {
								setShowLoad(false);
								navigate("/guias_despacho/crear");
							}}
						>
							<span>{textConstants[user.customer.country_id].delivery}</span>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</Row>
	);
};

export default InventoryFunctions;
